// src/index.ts
var XStorageError = class extends Error {
  constructor(name, message, origin) {
    super(message);
    this.message = message || "";
    this.name = name;
    this.origin = origin || location.origin;
  }
};
var createNSError = (ns, err) => {
  err.name = `${ns}:${err.name}`;
  return err;
};
export {
  XStorageError,
  createNSError
};
